// extracted by mini-css-extract-plugin
module.exports = {"arrow":"xq_qk"};